import { render, staticRenderFns } from "./BasicDataViewTitleConfigComponent.vue?vue&type=template&id=60957546&"
import script from "./BasicDataViewTitleConfigComponent.vue?vue&type=script&lang=js&"
export * from "./BasicDataViewTitleConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports